export function getDefaultLocation(locations) {
  if (!locations) return undefined;
  return locations[0];
}
